import type { LinkProps } from '@/ui-components/atoms/Link/Link';
import type { HelpCenterItem, NavItem } from '@/ui-components/organisms/NavHeader/NavHeader.type';

interface NavigationHelpCenterLink extends LinkProps {
    authenticatedLink?: LinkProps;
}

export interface NavigationHelpCenterItem extends HelpCenterItem {
    linkSet: Omit<HelpCenterItem['linkSet'], 'links'> & { links: NavigationHelpCenterLink[] };
}

export function mapSiteLinkToHelpCenterLink(link: SiteLink): NavigationHelpCenterLink {
    const authenticatedFields = link.fields.authenticated_link?.fields;

    return {
        children: link.fields.link_text,
        href: link.fields.href,
        ...(authenticatedFields?.href
            ? {
                  authenticatedLink: {
                      children: authenticatedFields.link_text || link.fields.link_text,
                      href: authenticatedFields.href,
                  },
              }
            : {}),
    };
}

export function resolveHelpCenterItem(
    item: NavigationHelpCenterItem | undefined,
    isAuthenticated: boolean,
): HelpCenterItem | undefined {
    if (!item) return undefined;

    return {
        ...item,
        linkSet: {
            ...item.linkSet,
            links: item.linkSet.links.map(({ authenticatedLink, ...defaultLink }) =>
                isAuthenticated && authenticatedLink?.href ? { ...defaultLink, ...authenticatedLink } : defaultLink,
            ),
        },
    };
}

export function mapSiteLinkToNavItem(link: SiteLink): NavItem {
    const { fields } = link;

    return {
        title: fields.link_text,
        link: fields.href,
        aria_label: fields.aria_label,
        link_type: fields.link_type,
        link_target: fields.link_target,
        authenticatedItem: fields.authenticated_link ? mapSiteLinkToNavItem(fields.authenticated_link) : undefined,
    };
}

export function resolveDesktopNavCtas(
    navItems: NavItem[] | undefined,
    isAuthenticated: boolean,
): NavItem[] | undefined {
    return navItems?.map((item) => (isAuthenticated && item.authenticatedItem ? item.authenticatedItem : item));
}

export function createNavigationCtaCollections(navItems: NavItem[] | undefined, isAuthenticated: boolean) {
    return {
        desktopNavRightCtas: resolveDesktopNavCtas(navItems, isAuthenticated),
        mobileNavRightCtas: navItems,
    };
}
